$(function() {
    $('#trigger_compare_tray').on('click', function () {
        $('#compare_tray').toggleClass('open');
        $('.backdrop--compare-tray').fadeIn(100);
        $(this).fadeOut(100);
        $('.header-compare-tray').fadeIn(100);
    });

    $('.backdrop--compare-tray, .close-compare-tray').on('click', function () {
        $('#compare_tray').removeClass('open');
        $('#trigger_compare_tray').fadeIn(100);
        $('.backdrop--compare-tray').fadeOut(100);
        $('.header-compare-tray').fadeOut(100);
    });
});
